import { useQuery, UseQueryResult } from "react-query";
import Request from "v2/domain/benefitRequest/entities/Request";
import findBenefitRequests from "v2/domain/benefitRequest/useCases/findBenefitRequests";

export default function useBenefitRequests({
  companyId,
  states,
  categories,
}: {
  companyId: string;
  states: string[];
  categories: string[];
}): UseQueryResult<Request[], Error> {
  return useQuery<Request[], Error>(
    ["companyBenefitRequests", companyId],
    () => findBenefitRequests({ companyId, states, categories }),
    {
      initialData: [],
    }
  );
}
